import { CRYPTO_KEYS } from 'resources'

export const FETCH_STATUSES = {
  NOOP: 'noop',
  REQUESTING: 'requesting',
  SUCCESS: 'success',
  FAILURE: 'failure',
}

export const REDEMPTION_OPTIONS_KEYS = {
  ...CRYPTO_KEYS,
  GIFT_CARD: 'giftCard',
}

export const CRYPTO_REDEMPTION_SCREEN_KEYS = {
  pointsConversionScreen: 'pointsConversionScreen',
  walletAddressEnteringScreen: 'walletAddressEnteringScreen',
  confirmationScreen: 'confirmationScreen',
}

export const TOKEN_REQUIRED_KEYS = [
  'crypto',
  'currency',
  'estimatedNetworkFeeCrypto',
  'exp',
  'expirationMinutes',
  'iat',
  'quoteCryptoPerAmount',
  'quotePrice',
  'userAlias',
]

export const ENDPOINTS = {
  EXTERNAL_REDEMPTION: '/v2/redemptions/external/',
  SHARES_REDEMPTION: '/v2/redemptions/shares/',
  TREMENDOUS_REDEMPTION: '/v2/redemptions/',
  TREMENDOUS_REDEMPTION_OPTIONS: '/v2/redemptions/options/',
  CRYPTO_REDEMPTION_OPTIONS: '/v2/redemptions/crypto/options/',
  CRYPTO_REDEMPTION_QUOTE: '/v2/redemptions/crypto/quote/',
  CRYPTO_REDEMPTION: '/v2/redemptions/crypto/redeem/',
}
